import { Tooltip } from '@mui/material';
import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { FAILED_STATUSES, PaymentsStatusEnum } from 'src/shared/models/enums/paymentsStatus.enum';

type PaymentStatusesProps = {
  status: number;
  statusMessage?: string;
  chipSize: 'small' | 'medium' | undefined;
};

export const PaymentStatuses = (props: PaymentStatusesProps) => {
  const { status, statusMessage, chipSize } = props;
  const { t } = useTranslation();
  const isFailed = FAILED_STATUSES.includes(status as PaymentsStatusEnum);
  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {isFailed ? (
        <Tooltip describeChild title={statusMessage || t(`invoice:payments.status${PaymentsStatusEnum[status]}Tooltip`)} arrow>
          <CustomChip label={t(`invoice:payments.status${PaymentsStatusEnum[status]}`)} color='warning' size={chipSize} />
        </Tooltip>
      ) : (
        <Tooltip describeChild title={`${t('invoice:payments.statusCompleted')}`} arrow>
          <CustomChip label={t('invoice:payments.statusCompleted')} color='success' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
